import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatListModule as MatListModule } from '@angular/material/list';
import { TranslateModule } from '@ngx-translate/core';
import { UploaderComponent } from './uploader.component';
import { UploaderService } from './uploader.service';

@NgModule({
  declarations: [UploaderComponent],
  exports: [UploaderComponent],
  providers: [UploaderService],
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatListModule,
    CommonModule,
    MatIconModule,
    MatRippleModule,
    TranslateModule,
    MatProgressSpinnerModule,
  ],
})
export class UploaderModule {}
